module.exports = __webpack_public_path__ + "img/开门按钮 (1).5a8d651e.jpg";